import { Device } from '@capacitor/device';
import { useContext, useEffect, useState } from 'react';
import { useGuidelinesProviderContext } from '../../services/GuidelinesProviderContext';
import { GuidelinesAppBar } from '../GuidelinesAppBar';
import { ThemeAndTitleContext } from '../ThemeAndTitleProvider';
import { NavigationBreadcrumbs } from './NavigationBreadcrumbs';
import { Page } from './Page';
import { PageHeading } from './PageHeading';

export function Guideline(): JSX.Element {
  const {
    guidelines,
    pageId,
    singlePageRender,
    metaData,
    textReplacements,
    targetUrl,
    getTargetUrlSection,
  } = useGuidelinesProviderContext();
  const { setThemeFromName, removeSiteSpecifierFromName, appTitle } =
    useContext(ThemeAndTitleContext);
  const [devicePlatform, setDevicePlatform] = useState('');

  useEffect(() => {
    const populateDevicePlatform = async () => {
      const info = await Device.getInfo();

      setDevicePlatform(info.platform);
    };

    populateDevicePlatform();
  }, []);

  const isEmptyGuideline = guidelines.pages.allPagesById.size === 0;
  if (isEmptyGuideline) {
    return <div />;
  }

  // If no page ID is passed then use the root page
  const pageIdToUse = pageId ?? guidelines.pages.rootPage.id;

  let guidelinePage = guidelines.pages.allPagesById.get(pageIdToUse);

  if (!guidelinePage) {
    return <div />;
  }

  if (targetUrl) {
    const microguideSection = getTargetUrlSection(targetUrl);
    guidelinePage = {
      ...guidelinePage,
      subheading: microguideSection.footer,
      id: 'microguide',
      sections: [{ ...microguideSection, footer: undefined }],
    };
  }

  setThemeFromName(guidelines.pages.rootPage.title);
  const pageTitle = removeSiteSpecifierFromName(guidelinePage.title);

  const isOnMobileApp = devicePlatform !== 'web';

  return (
    <>
      <GuidelinesAppBar appTitle={appTitle} showNav={isOnMobileApp} />
      <NavigationBreadcrumbs />
      <PageHeading
        heading={pageTitle}
        subheading={guidelinePage.subheading}
        onClick={() => {}}
      />
      <Page
        guideline={guidelinePage}
        allPages={guidelines.pages.allPagesById}
        singlePageRender={singlePageRender}
        metaData={metaData}
        textReplacements={textReplacements}
      />
    </>
  );
}
